module.exports = {
  "country": "UK",
  "artist": "Jade Ewen",
  "song": "Its my Time",
  "year": "2009",
  "place": "5",
  "spotify": "0q1PTDRFl64tIskcoIs2EO"
};